<span fxLayout="column" fxLayoutGap="10px" class="mat-app-background-2">
  <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="center start"
    class="overflow-hidden mb-0 mat-app-background-1">
    <span fxLayout="column" fxFill fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100" class="position-relative">


      <span fxLayout="column" fxLayoutGap="20px" fxFlex.xs="100" fxFlex="100" fxFill class="image-ratio-container res-img-height506-width100">
        <img width="100%" class="object-fit-cover absolute-zero" *ngIf="picture" [src]="picture | safe: 'resourceUrl'"
          [alt]="details?.title" (load)="imageLoaded = true" [class.loaded]="imageLoaded" (error)="onImgError()" fetchpriority="high" loading="eager"/>
      </span>
      <span fxLayout="column" class="position-absolute overlay-shade h-50 w-100 top-50" fxLayoutAlign="end space-between">
        <span fxLayout="row" fxLayoutAlign="center end">
          <span fxLayout="column" fxFill fxLayoutAlign="end">
            <span class="px-3 pb-3" fxLayout="row" fxLayoutAlign="end">
              <img *ngIf="showApproved()"
                [alt]="'searchList.selectors.ratingOptions.4' | translate" src="assets/media/rating_badge.svg"
                class="mt-auto mb-4 res-image-height-widht-58-36" />

              <div fxFlex="10px"></div>
              <app-age-category-badge [ageCategory]="details?.altersfreigabe" *ngIf="details?.rating?.id > 2" class="mt-auto res-image-height-widht-58-36"/>
              <div fxFlex="10px"></div>
              <app-traffic-lights class="res-image-height-width-148-76x58-30 res-pad-t-50-0" [rating]="details?.rating.id"></app-traffic-lights>

            </span>
          </span>
        </span>
      </span>
    </span>
  </span>



  <span fxLayout="row" fxLayoutAlign="center start" fxFill
    class="mat-app-background-1 res-pad-lr-0-20">
    <span fxLayout="column" fxLayoutGap="20px" fxFill fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100">
      <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="center start"
        class="image-overline-gap" fxLayoutGap="30px">
        <span fxLayout.sm="row" fxLayout.xs="row" fxLayout="column" fxFlex="568px" fxFlex.xs="100" fxFlex.sm="100">
          <span fxLayout="column" fxLayoutGap="10px" fxFlex.xs="100" fxFlex.sm="100" fxFill>
            <span class="primary-color mat-headline-1 overline-margin"> {{'besprechung.overline' | translate}} </span>
            <h1 class="mat-headline-2 overline-title-gap">{{details?.title}}</h1>
            <div *ngIf="(details && details.published !== undefined && !details.published)">{{'redtext.unpublished' | translate}}</div>
            <app-detail-icon-list  [details]="details" [chips]="chips" class="title-content-gap mobile-only"></app-detail-icon-list>

            <span fxLayout="column" fxFlex="40" fxLayoutGap="20px" class="image-overline-gap-LOCAL"
              *ngIf="details?.box1" class="mobile-only">
              <span class="flimmo-card box mobile-only" *ngIf="details?.box1">
                <markdown #mkBox1 [data]="details?.box1" class="mat-typography" (ready)="mkReady(mkBox1)"></markdown>
              </span>
            </span>

            <ng-template #elseBlock>
              <span class="mb1 title-content-gap">
                {{details?.content}}
              </span>
            </ng-template>
            <span class="mb1 title-content-gap">
              <markdown *ngIf="details && details?.contentMD && details?.contentMD.length > 0; else elseBlock" #mk
                [data]="details?.contentMD" (ready)="lh.wireInsertedLinks(mk.element)" class="mat-typography ">
              </markdown>
            </span>

            <span class="flimmo-card flimmo-meint-box" fxLayout="row" *ngIf="details">
              <span fxLayout="column" fxLayoutGap="20px">
                <span fxFlex="10" fxLayout="row" fxLayoutGap="12px" fxLayoutAlign="start center">
                  <img width="20" height="20" alt="FLIMMO" class="flimmo-meint-icon" src="assets/media/ico_play.svg">
                  <span class="primary-color mat-headline-1 center-h1">{{'besprechung.flimmoComment' | translate}}</span></span>
                <span fxFlex class="mb1">{{details?.paed}}</span>
                <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px" *ngIf="details?.warnung">
                  <div fxFlex="22px">
                    <mat-icon class="icon-warning">error_outline</mat-icon>
                  </div>
                  <span class="mb2">{{details?.warnung}}</span>
                </span>
                <span fxLayout="row" fxFlexAlign="center center" fxFlex="36px" class="align-self-center">
                  <button fxFlex="1 1" fxLayout="row" fxFill fxFlexAlign="center center"
                    class="align-items-center justify-content-center flimmo-outline-button f-button-label text-decoration-none black"
                    (click)="toLegend()">{{'besprechung.flimmoButton' | translate}}</button>
                </span>
              </span>
            </span>

            <app-quality-checklist class="ml-1 mobile-only" *ngIf="details?.rating.id === 4"
              [filledQualities]="filledQualities"></app-quality-checklist>

            <span fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start"
              fxLayoutGap="20px">
              <span fxLayout.sm="row" fxLayout.xs="row" fxLayout="column" fxFlex="568px" fxFlex.xs="100"
                fxFlex.sm="100">
                <app-qualities-list class="pt40px-LOCAL"
                  [qualities]="details?.rating?.qualities"></app-qualities-list>
              </span>
            </span>

            <span  fxFlex="40px" class="desktop-only">
            </span>

          </span>
        </span>
        <span fxLayout.sm="row" fxLayout.xs="row" fxLayout="column" class="mt-2 w-100">
          <app-detail-icon-list [chips]="chips" [details]="details" class="desktop-only"></app-detail-icon-list>

          <app-quality-checklist class="desktop-only" *ngIf="details?.rating?.id === 4" class="desktop-only"
            [filledQualities]="filledQualities"></app-quality-checklist>

          <span fxLayout="column" fxFlex="40" fxLayoutGap="20px" class="image-overline-gap-LOCAL"
            *ngIf="details?.box1" class="desktop-only">
            <span class="flimmo-card box desktop-only" *ngIf="details?.box1">
              <markdown #mkBox1 [data]="details?.box1" class="mat-typography" (ready)="mkReady(mkBox1)"></markdown>
            </span>
          </span>
        </span>
      </span>
      <span fxLayout="column" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="20px"
        class="pb-2" *ngIf="swimlanes?.items?.length == 0 && !loading">
        <span fxLayout="column" fxLayoutGap="20px" fxFlex fxFlex.sm="100" fxFlex.xs="100">
          <span fxLayout="row" fxLayoutGap="10px" class="opaquetexts-color" fxLayoutAlign="start center">
            <span fxLayout="column">
              <span fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
                <span class="f-copyright">{{'common.copyrightTitle' | translate}}</span></span>
              <span fxLayout="row" *ngIf="details?.imagec"><span
                  class="f-copyright-text">{{details?.imagec}}</span></span>
              <span fxLayout="row" *ngIf="details?.imagec == null"><span class="f-copyright-text">Myst -
                  stock.adobe.com</span></span>
            </span>
          </span>
        </span>
      </span>
    </span>
  </span>
  <span fxLayout="column" fxLayoutGap="20px" fxFlex.sm="100" *ngIf="swimlanes?.items?.length > 0 && !loading"
    class="mat-app-background-2 w-100 m-0 pt-4" fxFlex.xs="100">
    <span fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="20px">
      <swimlanes [swimlane]="swimlanes"></swimlanes>
    </span>

    <span fxLayout="column" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="20px"
      class="pb-2 mobile-only">
    </span>


    <span fxLayout="row" fxLayoutAlign="center start" fxFill class="res-pad-lr-0-20">
      <span fxLayout="column" fxLayoutGap="20px" fxFill fxFlex="0 1 900px" fxFlex.sm="100" fxFlex.xs="100">
        <span fxLayout="column" fxLayout.xs="column" fxLayout.sm="column" fxLayoutAlign="start start" fxLayoutGap="20px"
          class="pb-2">
          <span fxLayout="column" fxLayoutGap="20px" fxFlex fxFlex.sm="100" fxFlex.xs="100">
            <span fxLayout="row" fxLayoutGap="10px" class="opaquetexts-color" fxLayoutAlign="start center">
              <span fxLayout="column">
                <span fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
                  <span class="f-copyright">{{'common.copyrightTitle' | translate}}</span>
                </span>
                <!-- <span fxLayout="row"><span class="f-copyright-text">{{swimlaneCopyright}}</span> -->
                <span [matTooltip]="this.swimlaneCopyrightTooltip" matTooltipClass="multiline-tooltip" class="f-copyright-text">{{swimlaneCopyright}}</span>

              </span>
              </span>
            </span>
          </span>
        </span>
      </span>
    </span>

  </span>
